module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": 670
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancel($event)
      }
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "pa-4"
  }, [(_vm.visible) ? _c('youtube', {
    attrs: {
      "video-id": _vm.videoId,
      "player-vars": {
        autoplay: 1
      },
      "player-width": "100%"
    },
    on: {
      "ready": _vm.ready,
      "playing": _vm.playing
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b4fc348"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/YouTubeDialog.vue
// module id = 2635
// module chunks = 1